export default Object.freeze({ UPDATE_LOG: "UPDATE_LOG" });
